import { render, staticRenderFns } from "./PowderFoot.vue?vue&type=template&id=56b97065&"
var script = {}
import style0 from "./PowderFoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports